import React from "react";
import PrintIcon from "@mui/icons-material/Print";
import { useInvoicePrintTemplate } from "../../context/InvoicePrintTemplateContext";

function InvoicePrintTemplateSelector() {
  const { template, setTemplate, options, showSelector } = useInvoicePrintTemplate();

  if (!showSelector) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 px-2 py-1 bg-slate-100 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700">
      <div className="hidden md:flex items-center gap-1.5 text-slate-600 dark:text-slate-300">
        <PrintIcon sx={{ fontSize: 16 }} />
        <span className="text-xs font-semibold whitespace-nowrap">Print:</span>
      </div>
      <div className="flex gap-1">
        {options.map(({ value, label }) => (
          <button
            key={value}
            type="button"
            onClick={() => setTemplate(value)}
            className={`px-2.5 py-1 rounded-lg text-xs font-medium transition-all whitespace-nowrap ${
              template === value
                ? "bg-white dark:bg-slate-700 text-indigo-600 dark:text-indigo-400 shadow-sm"
                : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default InvoicePrintTemplateSelector;
